export const mainTheme = {
  bg: "#58003d",
  text_primary: "#F998EF",
  card: "#171721",
  card_light: "#191924",
  arrow: "#22222db0",
  white: "#FFFFFF",
  gradient:
    "linear-gradient(to right, rgb(255, 68, 197) 0%, rgb(255, 241, 163) 100%)",
};
